import React, { useState, useEffect } from 'react';
import styles from './oneWayInterview.module.scss';
import { Card, Col, Container, Row, Image } from 'react-bootstrap';
import { getAllOneWayInterviewGroups } from '../../../services/util/oneWayInterview';
import CSSLoader from '../../shared/cssLoader';
import { Helmet } from "react-helmet";
import ReactGA from 'react-ga4';
import CustomNavbar from '../customNavbar';
import { CustomButton } from '../../shared/customButton';
import { Tooltip as ReactTooltip } from 'react-tooltip'
import { CustomAlertBox } from '../../shared/customAlertBox';
import { CustomAvatarList } from '../../shared/customAvatarList';
import { CustomPreIcon } from '../../shared/customPreIcon';

const OneWayInterview = (props) => {
    let concatValue;
    const [isLoading, setLoading] = useState(false);
    let [oneWayInterviewReviewValues, setOneWayInterviewValues] = useState([]);
    const breadcrumb = [
        {
            pathaddress: '/app/company/one_way_interviews',
            pathname: 'One Way Interviews',
            isActive: false,
            key: 1 + 'one-way-interview'
        }
    ]

    const breacrumbText = 'Here you can see one-way interview answers which are submitted by candidates and waiting for your feedback. Review the video recorded answers and submit your ratings.'

    const getAllOneWayInterviewReviews = async () => {
        setLoading(true)
        const values = await getAllOneWayInterviewGroups();
        if (values.success === true) {
            setOneWayInterviewValues(values.data)
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    function ViewOneWayInterviewDetails(step_id) {
        props.history({
            pathname: `/company/one-way-interviews/group`,
            search: `?step_id=${step_id}`
        });
    }

    function addMaxViewLength(values, size) {
        concatValue = values.length > size ? values.slice(0, size - 1) + "…" : values;
    }

    function truncateValue(value, maxLength) {
        return value.length > maxLength ? value.slice(0, maxLength - 1) + "…" : value;
    }

    // Company Settings Integration API call
    let [isURLLoading, setURLLoading] = useState(false);


    useEffect(() => {
        getAllOneWayInterviewReviews();
    }, []);

    useEffect(() => {
        let pageHit = '/app/company/one_way_interviews';
        props.toggleInterviewView(false);
        ReactGA.initialize(`${process.env.REACT_APP_CUSTOMER_FLOW_GOOGLE_ANALYTICS_ID}`);
        ReactGA.send({ hitType: "pageview", page: pageHit});
    }, [])


    return (
        <div>
            <Helmet>
                <title>One Way Interview | HireTrace</title>
            </Helmet>
            {isLoading === true ?
                (<div className={styles.loadingDiv}>
                    <Col sm={{ span: 4, offset: 4 }}>
                        <CSSLoader />
                    </Col>
                </div>)
                :
                (<div>
                    <div className={styles.backgroundFixedComponents}>
                        <CustomNavbar history={props.mainHistory} breadcrumbArray={breadcrumb} breacrumbText= {breacrumbText}/>
                    </div>
                    <div className={styles.BodyContainer}>
                        <Col>
                            <Row>
                                {
                                    (oneWayInterviewReviewValues).map((values, index) => (
                                        <Col sm={6} lg={4} className="mb-4" key={index}>

                                            <Card className={styles.cardOuterBox}>
                                                <Card.Body >
                                                    <div className={styles.cardTitleBox}>
                                                        <CustomPreIcon
                                                            type="successIcon"
                                                            icon={
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                                                    <path d="M6.94075 19.25C8.16431 18.6631 9.54239 18.3333 10.9999 18.3333C12.4574 18.3333 13.8355 18.6631 15.0591 19.25M6.23325 15.5833H15.7666C17.3067 15.5833 18.0768 15.5833 18.6651 15.2836C19.1825 15.0199 19.6032 14.5993 19.8669 14.0818C20.1666 13.4936 20.1666 12.7235 20.1666 11.1833V7.15C20.1666 5.60986 20.1666 4.83978 19.8669 4.25153C19.6032 3.73408 19.1825 3.31338 18.6651 3.04973C18.0768 2.75 17.3067 2.75 15.7666 2.75H6.23325C4.69311 2.75 3.92304 2.75 3.33478 3.04973C2.81733 3.31338 2.39664 3.73408 2.13298 4.25153C1.83325 4.83978 1.83325 5.60986 1.83325 7.15V11.1833C1.83325 12.7235 1.83325 13.4936 2.13298 14.0818C2.39664 14.5993 2.81733 15.0199 3.33478 15.2836C3.92304 15.5833 4.69311 15.5833 6.23325 15.5833Z" stroke="#039855" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                </svg>
                                                            }
                                                        />
                                                        <div className={styles.cardTitleText}>
                                                            <p className={styles.cardTitlePrimaryText} data-tooltip-id={values.pipeline_name + index} onChange={addMaxViewLength(values.pipeline_name, 80)}>{concatValue}</p>
                                                            {(values.pipeline_name).length > 80 &&
                                                                <ReactTooltip id={values.pipeline_name + index} place="bottom" type="dark" effect="solid">
                                                                    <span>{values.pipeline_name}</span>
                                                                </ReactTooltip>
                                                            }
                                                            <p className={styles.cardTitleSecondaryText}>
                                                                {truncateValue(values.hiring_position, 22)}
                                                                <span className={styles.cardTitleSecondarySubText}>|</span>
                                                                {truncateValue(values.step_name, 22)}
                                                            </p>

                                                            {(values.hiring_position).length > 22 &&
                                                                <ReactTooltip id={values.hiring_position + index} place="bottom" type="dark" effect="solid">
                                                                    <span>{values.hiring_position}</span>
                                                                </ReactTooltip>
                                                            }
                                                            {(values.step_name).length > 22 &&
                                                                <ReactTooltip id={values.step_name + index} place="bottom" type="dark" effect="solid">
                                                                    <span>{values.step_name}</span>
                                                                </ReactTooltip>
                                                            }
                                                        </div>
                                                    </div>
                                                    <hr className={styles.horizontalDivider} />
                                                    <div className={styles.cardBodyText}>
                                                        <p >
                                                            {`${values.job_type === 10 ? "Full-Time" : values.job_type === 20 ? "Part-Time" : values.job_type === 30 ? "Contract/ Temp" : values.job_type === 40 ? "Casual/ Vacation" : values.job_type === 50 ? "Internship" : ''}`}
                                                            {values.work_type === 10 ? (<><span className={styles.cardBodySubText}>|</span><span>Remote</span></>) : values.work_type === 20 ? (<><span className={styles.cardBodySubText}>|</span><span>On-site</span></>) : values.work_type === 30 ? (<><span className={styles.cardBodySubText}>|</span><span>Hybrid</span></>) : null}
                                                            {values.location ? <><span className={styles.cardBodySubText}>|</span><span>{values.location}</span></>: null}
                                                        </p>
                                                    </div>
                                                    <div className={styles.reviewDetails}>
                                                        <div>
                                                            <CustomAvatarList nameArray={values.top_candidate_name_list} totalUsers={values.candidate_count}></CustomAvatarList>
                                                        </div>
                                                        <div className={styles.cardBtn}>

                                                            <CustomButton
                                                                buttonType="button"
                                                                label="Start Review"
                                                                type="secondaryBtn"
                                                                backicon={
                                                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M9 12L12 9L9 6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                        <path d="M6 9H12" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                    </svg>
                                                                }
                                                                handleClick={() => ViewOneWayInterviewDetails(values.step_id)}
                                                            />
                                                        </div>
                                                    </div>
                                                </Card.Body>
                                            </Card>


                                        </Col>
                                    ))

                                }
                            </Row>
                        </Col>
                        <div className={styles.NoContainer}>
                            {
                                oneWayInterviewReviewValues.length === 0 &&
                                (<div>
                                    <Col>
                                        {/* <p className={styles.infoMessage}>Currently no One Way Interviews assigned to you to review. Learn more
                                                    about  <a href='https://hiretrace.io/documentation/cv-reviews/overview' target="_blank">One Way Interviews</a>. </p> */}
                                        <p className={styles.infoMessage}>Currently no One Way Interviews assigned to you to review. </p>
                                    </Col>
                                    <Col xs={{ span: 6, offset: 3 }} sm={{ span: 4, offset: 4 }}>
                                        <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/cvReview.svg`} fluid />
                                    </Col>
                                </div>)
                            }
                        </div>
                    </div>

                </div>)
            }
        </div>
    )
}
export default OneWayInterview;